import {AcLockObject} from '@opp/ui-kit';

const AUTH = '/auth';
const CHART = '/chart';
const LOGIN = '/login';
const LOGOUT = '/auth';
const NOTIFICATIONS = '/notifications';
const ACCOUNTS = '/accounts';
const BANK_ACCOUNTS = '/bank-accounts';
const DOWNLOAD = '/download';
const EVENTS = '/events';
const LOG = '/log';
const OAUTH = '/oauth';
const PROFILE = '/my-profile';
const PROFILES = '/profiles';
const REPORTS = '/reports';
const ROWS = '/rows';
const SEARCH = '/search';
const SETTLEMENTS = '/settlements';
const SPECIFICATIONS = '/specifications';
const STATISTICS = '/statistics';
const TICKETS = '/tickets';
const TOKEN = '/token';
const TOKENS = '/tokens';
const TOTALS = '/totals';
const TRACKING = '/tracking';
const TRANSACTIONS = '/transactions';
const MOVEMENTS = '/movements';
const PURCHASES = '/purchases';
const COMPLIANCE_REQUIREMENTS = '/compliance_requirements';
const UPLOAD = '/upload';
const USER = '/user';
const USERS = '/users';
const USER_INFO = '/userinfo';
const UI = '/ui';
const WHOAMI = '/whoami';
const BALANCE = '/balance';
const SETTINGS = '/settings'
const REFUNDS = '/refunds';
const REFUNDABLE = '/refundable';
const PAYOUTS = '/payouts';
const TOPUPS = '/topups';
const WITHDRAWALS = '/withdrawals';
const REPORTING = '/reporting';
const GET_PAYMENT_METHODS = '/parent-payment-methods'


// V1
export const ENDPOINTS = AcLockObject({
  AUTH: {
    LOGIN: `${AUTH}`, // POST
    REFRESH_TOKEN: `${OAUTH}${TOKEN}`, // POST
    LOGOUT: `${OAUTH}${TOKEN}`, // DELETE
  },
  PROFILE: {
    LIST: `${USERS}${WHOAMI}`, // GET
    COLLECTION: `${PROFILES}`, // GET
    WHOAMI: `${USER_INFO}`, // GET
    UPDATE: `${USER_INFO}`, // PUT
  },
  USER: {
    DELETE: `${USER}`, // DELETE
  },
  GLOBAL: {
    SEARCH: `${SEARCH}`, // POST,
    STATISTICS: {
      TOTALS: `${STATISTICS}${TOTALS}`, // GET
      CHART: `${STATISTICS}${CHART}`, // GET
    },
  },
  EVENTS: {
    LIST: `${EVENTS}`, // GET
  },
  BANK_ACCOUNTS: {
    LIST: `${BANK_ACCOUNTS}`, // GET
    GET_BY_ID: (_uid) => `${BANKS}${ACCOUNTS}/${_uid}`, // GET
  },
  SETTLEMENTS: {
    LIST: `${SETTLEMENTS}`, // GET
    GET_BY_ID: (_uid) => `${SETTLEMENTS}/${_uid}`, // GET
    SPECIFICATIONS: {
      LIST: (_uid) => `${SETTLEMENTS}/${_uid}${SPECIFICATIONS}`, // GET
      GET_BY_ID: (_uid, _specification_uid) =>
        `${SETTLEMENTS}/${_uid}${SPECIFICATIONS}/${_specification_uid}`, // GET
      GET_ROWS_BY_ID: (_uid, _specification_uid) =>
        `${SETTLEMENTS}/${_uid}${SPECIFICATIONS}/${_specification_uid}${ROWS}`, // GET
    },
  },
  TICKETS: {
    LIST: `${TICKETS}`, // GET
    GET_BY_ID: (_uid) => `${TICKETS}/${_uid}`, // GET
    STORE: `${TICKETS}`, // POST
  },
  WITHDRAWALS: {
    GET_BY_ID: (_uid) => `${WITHDRAWALS}/${_uid}`, // GET
  },
  MOVEMENTS: {
    LIST: `${MOVEMENTS}`, // GET
    GET_BY_ID: (_uid) => `${MOVEMENTS}/${_uid}`, // GET
    GET_PAYMENT_METHODS: () => `${MOVEMENTS}${GET_PAYMENT_METHODS}`, // GET
  },
  TRANSACTIONS: {
    GET: (_uid) => `${TRANSACTIONS}`, // GET
    GET_BY_ID: (_uid) => `${TRANSACTIONS}/${_uid}`, // GET
    STORE_REFUND: (_uid) => `${TRANSACTIONS}/${_uid}${REFUNDS}`, // POST
    REFUNDABLE: (_uid) => `${TRANSACTIONS}/${_uid}${REFUNDABLE}`, // GET
    GET_PAYOUTS: (_uid) => `${TRANSACTIONS}/${_uid}${PAYOUTS}`, // GET
    STORE_TOPUP: `${TOPUPS}`, // POST
    GET_LOG: (_uid) => `${TRANSACTIONS}/${_uid}${LOG}`, // GET
    GET_TRACKING: (_uid) => `${TRANSACTIONS}/${_uid}${TRACKING}`, // GET
    GET_TRACKING_BY_ID: (_uid, _tracking_uid) =>
      `${TRANSACTIONS}/${_uid}${TRACKING}/${_tracking_uid}`, // GET
  },
  PURCHASES: {
    LIST: `${PURCHASES}`, // GET
    GET_BY_ID: (_uid) => `${PURCHASES}/${_uid}`, // GET
  },
  BALANCE: {
    GET: `${BALANCE}`, // GET
    GET_PROFILE: (_uid) => `${PROFILES}/${_uid}${BALANCE}`, // GET
    WITHDRAW: `${WITHDRAWALS}`, // POST
  },
  COMPLIANCE_REQUIREMENTS: {
    LIST: `${COMPLIANCE_REQUIREMENTS}`, // GET
  },
  SETTINGS: {
    GET: `${SETTINGS}`, // GET
  },
  REPORTING: {
    REPORT: `${REPORTING}` // POST
  }
});

export default ENDPOINTS;
